import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {injectIntl, intlShape} from 'react-intl';

const Title = ({
  title,
  intl,
  children,
  titleClassName,
  className,
  backLink,
  compactView,
  dispatch,
  forceShow,
  ...props
}) =>
  compactView && backLink && !children && !forceShow ? null : (
    <div className={classNames('block-title', {'with-back': backLink}, className)} {...props}>
      {backLink}

      {children}

      {title && <div className={classNames('title', titleClassName)}>{title}</div>}
    </div>
  );

Title.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  title: PropTypes.string,
  backLink: PropTypes.node,
  compactView: PropTypes.bool.isRequired,
  dispatch: PropTypes.func,
  forceShow: PropTypes.bool.isRequired,
  intl: intlShape
};

Title.defaultProps = {
  forceShow: false
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default injectIntl(connect(mapStateToProps)(Title));



// WEBPACK FOOTER //
// ./components/Form/Title.jsx